import { merge } from 'lodash';
import displaySettingsParams from './Tabs/Display/settingsParams';

const settingsParams = merge(displaySettingsParams);

export default settingsParams;
